import ParameterValidator from './ParameterValidator';

/**
 * callback function that is run after the timer ends without success
 */
function onEndDefault() {
	console.warn( 'waitForExpression :: timer ended without success' );
};

/**
 * a helper function that evaluates an expression every X milliseconds until true or until the maximum wait time is reached; then runs a callback funciton on success or error
 * 
 * @param {Function} expression a function that will be evaluated every tick, stops the process if true
 * @param {Function} onSuccess a function that is called on success
 * @param {Object} options optional parameters
 */
export default function waitForExpression( expression, onSuccess, { intervalTime = 200, maxWaitTime = 5000, onEnd = onEndDefault } = {} ) {

	// create validator class
	const validator = new ParameterValidator( 'waitForExpression' );
	
	// validate passed parameters
	expression = validator.isFunction( 'expression', expression );
	onSuccess = validator.isFunction( 'onSuccess', onSuccess );
	intervalTime = validator.isInt( 'intervalTime', intervalTime );
	maxWaitTime = validator.isInt( 'maxWaitTime', maxWaitTime );
	onEnd = validator.isFunction( 'onEnd', onEnd );

	// define properties
	let interval;
	const startTime = Date.now();

	// define private funcitons
	const onTick = function() {

		let remainingTime = Date.now() - startTime;
		let result = expression( remainingTime );

		// check if expression is true or timer ended
		if ( result || remainingTime > maxWaitTime ) {

			clearInterval( interval );

			return ( result ) ? onSuccess() : onEnd();

		}

	};

	// start interval loop
	interval = setInterval( onTick, intervalTime );

};